// src/components/SendEmailPopup/EmailPopup.js
import React, { useState,useEffect } from 'react';
import { Modal, Button, Form, Input, Select } from 'antd';
import RichEditor from 'components/RichEditor/index.js';
import Uploader from './Uploader';
import styled from 'styled-components';
import Label from 'components/Form/Label'
import { useSelector } from 'react-redux';
import authRequest from 'utils/authRequest'
import studentRequest from '../../utils/studentRequest';
// In src/components/SendEmailPopup/EmailPopup.js
const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    color: #4D566E;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
  }

  margin-bottom: 12px !important;

  .ant-form-item-required::before {
    display: none !important;
  }
  
  .ant-form-item-required::after {
    display: inline-block;
    margin-left: 4px;
    color: #ff4d4f;
    font-size: 14px;
    line-height: 1;
    content: "*";
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    display: none;
  }
  
  .ant-modal-body {
    padding: 20px 24px;
  }
`;

const HeaderText = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 20px;
`;
const EmailPopup = ({ visible, onCancel, onSend, onSuccess, selectedExportType,
    companyName,
    roleName,
    signatureName,
    signatureRole,
    signatureInstitute,
    googleSheetUrl,
    roleId,
    instituteCampusId,
    exportFile, // Receive prop
    selectedCandidateId, // Receive selected student IDs array
    filters, // Receive filters prop
    stageName,
    totalStudentsCount,
    selectAll,
    isTpo,
    offerStatus
 }) => {
    console.log(selectedExportType,'selectedExportType')
    console.log(stageName,'stageName')
  const [form] = Form.useForm();
  const [attachments, setAttachments] = useState([]);
  const [emailAttachments, setEmailAttachments] = useState([]); // New state for Base64 content
  const [loading, setLoading] = useState(false); // 1. Add loading state
  const userData = useSelector(state => state.auth.userData)
  const [emailBody,setEmailBody] = useState('')
  const [editorKey, setEditorKey] = useState(0);
  console.log(userData,'userData')
  const email = userData?.email
  console.log(email,'email')

  // Add function to remove attachments
  const removeAttachment = (index, fileName) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
    setEmailAttachments(prev => prev.filter(f => f.filename !== fileName));
  };

const handleSend = async () => {
  try {
    const values = await form.validateFields();
    console.log('Form values:', values);
    console.log('Attachments:', attachments);
    console.log("Role ID:", roleId);
    console.log("Institute Campus ID:", instituteCampusId);

    // Check if user is authorized
    try {
      const authCheck = await authRequest(
        `/gmail/isAuthorized?email=${encodeURIComponent(email)}`
      );
      console.log(authCheck,'authCheck')
      
      // 1. Wait for authorization if needed (BLOCKING)
      if (!authCheck?.data?.data?.authorized) {
        try {
          await startPopupAuth(email);
        } catch (err) {
          console.error('Popup failed:', err.message);
          return; // Stop if auth fails
        }
      }

      const isZipRequired = selectedExportType.includes('cv_zip');
      

      let bodyData = {
        from: email,
        to: values.to, // Pass array
        cc: values.cc || [], // Pass array
        subject: values.subject,
        body: values.message,
        attachments: emailAttachments,
        roleId,
        instituteCampusId,
        isZipRequired,
        studentIds: selectedCandidateId && selectedCandidateId.length > 0 && !selectAll ? selectedCandidateId : undefined,
        filters: filters, // Pass filters to backend
        stage: stageName,
        roleName: roleName,
        isTpo: isTpo,
        offerStatus: offerStatus,
      }

      setLoading(true); // 2. Start loading state immediately before sending

      // 2. Send request in background (NON-BLOCKING)
      authRequest.post('/gmail/send', bodyData)
        .then(result => {
           console.log('Background email sent:', result);
           // Call onSend when it actually finishes to ensure data consistency
           onSend && onSend(result); 
        })
        .catch(error => {
           console.error('Background email send failed:', error);
        });

      console.log(JSON.stringify(bodyData, null, 2), 'bodyData');

      // 3. Wait 2 seconds, then trigger parent success handler
      setTimeout(() => {
        setLoading(false); // Stop loading (though component unmounts anyway)
        if (onSuccess) {
          onSuccess(); // This will close EmailPopup and open SuccessDialog in parent
        } else {
          onCancel(); // Fallback if onSuccess not provided
        }
      }, 2000);
      
    } catch (error) {
      console.error('Error checking auth or preparing data:', error);
      setLoading(false); // Stop loading on error
    }
  } catch (error) {
    console.error('Form validation failed:', error);
    // Don't set loading here as it failed before starting
  }
};

// Add this function to handle file reading
const handleAttachment = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Upload to Oracle via Student Node API
    const response = await studentRequest.post('/students/assessments/uploadFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response?.data?.message === 'success' && response?.data?.data) {
      const { parUrl, contentType } = response.data.data;
      
      setEmailAttachments((prev) => [
        ...prev,
        {
          url: parUrl, // Store the signed URL
          filename: file.name,
          mimeType: file.type || contentType, 
          // No longer storing 'content' (base64)
        },
      ]);
    } else {
        console.error('Upload failed:', response);
    }
  } catch (error) {
    console.error('Error processing attachment:', error);
  }
};

// Effect to handle the passed export file
useEffect(() => {
  if (exportFile) {
     // Avoid adding if already present (simple check by name)
     setAttachments(prev => {
         const exists = prev.some(f => f.name === exportFile.name);
         if (exists) return prev;
         return [...prev, exportFile];
     });
     
     // Process for sending (Base64) if not already processed
     setEmailAttachments(prev => {
         const exists = prev.some(f => f.filename === exportFile.name);
         if (!exists) {
             handleAttachment(exportFile);
         }
         return prev;
     });
  }
}, [exportFile]);

// OAuth popup handling
const startPopupAuth = async (email) => {
  try {
    const response = await authRequest('/gmail/auth/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: { email }
    });
    console.log(response,'response')
    if (!response?.data?.data?.authUrl) {
      throw new Error('No auth URL received');
    }
    
    const popup = window.open(response.data.data.authUrl, 'authPopup', 'width=600,height=700');
    if (!popup) {
      throw new Error('Popup was blocked. Please allow popups for this site.');
    }
    
    return new Promise((resolve) => {
      const checkPopup = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(checkPopup);
          resolve();
        }
      }, 500);
    });
  } catch (error) {
    console.error('Auth error:', error);
    throw error;
  }
};


  useEffect(() => {
    if (!visible) return;

    const hasCvZip = selectedExportType.includes('cv_zip');
    const hasGoogleSheet = selectedExportType.includes('googlesheet');
    const hasExcel = selectedExportType.includes('xlsx') || selectedExportType.includes('csv');
    
    // Default subject
    const subject = `Applied Candidates List - ${roleName} - ${signatureInstitute}`;
    
    // Default message based on selected export types
    let message = `Dear ${companyName || 'Recipient'},<br/><br/>`;
    
    if (hasGoogleSheet && hasCvZip) {
      message += `Please find below the Google Sheet link containing the list of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
      message += `We have also attached a ZIP file with all the candidate CVs for your reference.<br/><br/>`;
      message += `Google Sheet Link:<br/>`;
      message += `<a href="${googleSheetUrl}" target="_blank" rel="noopener noreferrer">View Google Sheet</a><br/><br/>`;
    } else if (hasExcel && hasCvZip) {
      message += `Please find attached the Excel file containing the list of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
      message += `We have also included a ZIP file with all the candidate CVs for your convenience.<br/><br/>`;
    } else if (hasGoogleSheet) {
      message += `Please find below the Google Sheet link containing the list of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
      message += `Google Sheet Link:<br/>`;
      message += `<a href="${googleSheetUrl}" target="_blank" rel="noopener noreferrer">View Google Sheet</a><br/><br/>`;
    } else if (hasExcel) {
      message += `Please find attached the Excel file containing the list of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
      message += `If you need the data in Google Sheet, CSV, or any alternate format, please feel free to reach out.<br/><br/>`;
    } else if (hasCvZip) {
      message += `Please find attached the ZIP file containing the CVs of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
    } else {
      message += `Please find the list of students from ${signatureInstitute} who have applied for the role ${roleName}.<br/><br/>`;
    }

    if(hasCvZip) { 
        const buttonStyle = "display: inline-block; padding: 10px 20px; background-color: #1890ff; color: white; text-decoration: none; border-radius: 5px; font-weight: bold; margin-top: 10px;";
        // The backend will replace {{ZIP_DOWNLOAD_LINK}} with the actual link
        message += `<br/><a href="{{ZIP_DOWNLOAD_LINK}}" style="${buttonStyle}">Download CV Zip Link Will be provided here</a><br/><br/>`;
    }

    // Add signature
    message += `Regards,<br/>${userData?.first_name + ' ' + userData?.last_name || ''}<br/>${signatureRole || ''}<br/>${signatureInstitute || ''}`;

    // Set form values
    form.setFieldsValue({
      subject,
      message
    });

    console.log(message,'message')
    setEmailBody(message)
    setEditorKey(prev => prev + 1);
  }, [visible]);
// Add this function for OAuth popup handling


  return (
    <>
    <StyledModal
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button 
          key="send" 
          type="primary" 
          onClick={handleSend} 
          loading={loading} // 3. Show loading spinner on button
        >
          {loading ? 'Sending...' : 'Send Email'}
        </Button>,
      ]}
      width={700}
      closable={!loading} // Prevent closing while loading
      maskClosable={!loading} // Prevent clicking outside while loading
    >
        <HeaderText>Send Email</HeaderText>
      <Form form={form} layout="vertical">
      <Label>To*</Label>
        <StyledFormItem
          name="to"
          rules={[
            { required: true, message: 'Please enter recipient email' },
            { 
              validator: (_, value) => {
                if (!value || value.length === 0) return Promise.resolve();
                // Support array validation
                const emails = Array.isArray(value) ? value : [value];
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalid = emails.find(email => !emailRegex.test(email));
                if (invalid) return Promise.reject(new Error(`Invalid email: ${invalid}`));
                return Promise.resolve();
              }
            }
          ]}
        >
          <Select mode="tags" placeholder="Enter recipient emails" tokenSeparators={[',', ' ']} open={false} />
        </StyledFormItem>
        
        <Label>Cc</Label>
        <StyledFormItem
          name="cc"
          rules={[
            { 
              validator: (_, value) => {
                if (!value || value.length === 0) return Promise.resolve();
                const emails = Array.isArray(value) ? value : [value];
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalid = emails.find(email => !emailRegex.test(email));
                if (invalid) return Promise.reject(new Error(`Invalid email: ${invalid}`));
                return Promise.resolve();
              }
            }
          ]}
        >
          <Select mode="tags" placeholder="Enter CC emails" tokenSeparators={[',', ' ']} open={false} />
        </StyledFormItem>

        <Label>Subject*</Label>
        <StyledFormItem
          name="subject"
          rules={[{ required: true, message: 'Please enter subject' }]}
        >
          <Input placeholder="Enter subject" />
        </StyledFormItem>
        <StyledFormItem
          name="message"
          rules={[{ required: true, message: 'Please enter message' }]}
        >
          <div
            onMouseDownCapture={e => {
              const anchor = e.target?.closest ? e.target.closest('a') : null
              if (anchor && anchor.href) {
                e.preventDefault()
                e.stopPropagation()
                window.open(anchor.href, '_blank', 'noopener,noreferrer')
              }
            }}
          >
            <RichEditor 
  key={`editor-${editorKey}`} // This forces a remount when emailBody changes
  labelName="Email Body*" 
  value={emailBody}
  onChange={(value) => {
    setEmailBody(value);
    form.setFieldsValue({ message: value });
  }} 
  placeholder="Enter message"
/>
          </div>
        </StyledFormItem>
        <Label style={{ marginBottom: '8px', display: 'block' }}>Attach Additional Files (if any)</Label>
        <StyledFormItem>
          <Uploader
            compactMode={true}
            format="*"
            setFile={setAttachments}
            handleFileChange={handleAttachment} // Pass the handler here
            multiple
            skipInternalUpload={true}
          />
          {/* Add Attachment Preview List */}
          {attachments.length > 0 && (
            <div style={{ marginTop: 10 }}>
              {attachments.map((file, index) => (
                <div 
                    key={index} 
                    style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        marginBottom: 8, 
                        padding: '8px 12px', 
                        background: '#f5f5f5', 
                        borderRadius: 4,
                        fontSize: '13px'
                    }}
                >
                   <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '90%' }}>
                     {file.name}
                   </span>
                   <span 
                     style={{ cursor: 'pointer', color: '#ff4d4f', marginLeft: 10, fontWeight: 'bold' }}
                     onClick={() => removeAttachment(index, file.name)}
                     title="Remove attachment"
                   >
                     ✕
                   </span>
                </div>
              ))}
            </div>
          )}
          {selectedExportType.includes('cv_zip') && (
            <div style={{ 
              marginTop: 16, 
              padding: '12px 16px', 
              background: '#f0f5ff', 
              borderRadius: 4,
              fontSize: '14px',
              color: '#4D566E',
              lineHeight: '1.6'
            }}>
              This email will include the <strong>CV ZIP</strong> file for <strong>{selectAll ? totalStudentsCount : (selectedCandidateId && selectedCandidateId.length > 0 ? selectedCandidateId.length : totalStudentsCount)} students</strong>. The file will be attached to the email.
            </div>
          )}
        </StyledFormItem>
      </Form>
    </StyledModal>
    </>
  );
};

export default EmailPopup;